import SnippetsGrid from '../../components/snippetsGrid';
import { Link } from "react-router-dom";
import {linkStyle} from "../../components/helpersStyles";
//import { IconButton, Tooltip } from '@mui/material';
//import { Icon as Iconify } from '@iconify/react';
import { CcCreateNewSnippet, CcSubSectionTitle, CcTitle } from '../../commonComponents/styledTexts';
import { useEffect } from "react";
import { InfoToolTip } from "../../commonComponents/generalComponents"

export default function ProductHomeSlidingPuzzle() {
    useEffect(() => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }, [])

    return <div>
            <CcTitle>
                Sliding Puzzle
            </CcTitle>

            <div className=" text-ccColorDarkTeal">With Timed Images, you decide what your audience sees and when. Create your schedule to change images based on date and time, perfect for seasonal campaigns, last-minute content changes, or controlling what’s visible after your emails are sent.</div>

            <Link to={`/workflow/20`} style={linkStyle}>
                <CcCreateNewSnippet className="mt-4" >Create a Sliding Puzzle</CcCreateNewSnippet>
            </Link>

            <CcSubSectionTitle className=" mt-6">Latest Sliding Puzzle Elements</CcSubSectionTitle>
            <SnippetsGrid productTypeId={20}
                 //editCall={(id, typeId) => editSnippet(id, typeId)}
             />

    </div>
}